var map = {
	"./Logo.svg": 3455,
	"./accessori.svg": 8112,
	"./laboratorio.svg": 9128,
	"./laboratorio_1.svg": 2204,
	"./negozio.svg": 4903,
	"./noleggio.svg": 6928,
	"./pattini.svg": 815,
	"./quote.svg": 5530,
	"./sci.svg": 4217,
	"./snow.svg": 6103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;